import type { ITimeSpan } from '@/objects/TimeSpan';
import type { Component } from 'vue';
import { InputNullableInt, InputFile, InputText } from '..';
import { markRaw } from 'vue';
import { ValidatorDef } from '@/objects/gui';

export class MultiEditorField<T = any> {
    TranslationKey: string;
    Value: T | null;
    Editor: Component<{ modelValue: T | null }>;
    Params: any;

    constructor(opts: { translationKey: string; value: T | null; editor: Component<{ modelValue: T | null }>; params?: any }) {
        this.TranslationKey = opts.translationKey;
        this.Value = opts.value;
        this.Editor = opts.editor;
        this.Params = opts.params ?? {};
    }
}

// Helper for extracting field values from dialog fields
export const getFieldValue = <T>(fields: Map<string, MultiEditorField<T>>, key: string): T | null => {
    return fields.get(key)!.Value;
};

// Helper for creating a text field
export const createTextField = (translationKey: string, defaultValue: string) => {
    return new MultiEditorField<string>({
        translationKey,
        value: defaultValue,
        editor: InputText,
        params: {},
    });
};

// Helper for creating integer fields
export const createIntField = (params: {
    defaultValue: number;
    translationKey: string;
    min?: number | null;
    max?: number | null;
    required?: boolean | null;
}) => {
    return new MultiEditorField<number>({
        translationKey: params.translationKey,
        value: params.defaultValue,
        editor: markRaw(InputNullableInt),
        params:
            params.min !== null || params.max !== null || params.required !== null
                ? { validator: new ValidatorDef({ Min: params.min ?? null, Max: params.max ?? null, Required: params.required ?? null }) }
                : {},
    });
};

// Helper for creating files field
export const createFileField = (translationKey: string) => {
    return new MultiEditorField<File | null>({
        translationKey: translationKey,
        value: null,
        editor: markRaw(InputFile),
        params: {},
    });
};
